module.exports = __webpack_public_path__ + "static/media/schlauch_loesung1.93320b4b.jpg";